import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import { PageWrapper } from '../../common/styled';

export const SearchInputWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px'
});

export const SearchButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  marginTop: '24px !important',
  borderRadius: '8px !important'
});
export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important',
  width: 'max-content',
  alignSelf: 'flex-end'
});

export const OptionsWrapper = styled(Box)({
  minHeight: 54,
  display: 'flex',
  alignItems: 'center',
  pl: 2
});

export const EditDeclarationWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16
});

export const SearchWrapper = styled(PageWrapper)({
  maxWidth: '100%',
  minHeight: 'auto'
});

export const AcademicYearWrapper = styled(Box)({
  maxWidth: 265,
  width: '100%'
});

export const AddDeclarationWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16
});

export const FileWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end'
});

export const DeclarationTableWrapper = styled(PageWrapper)({
  maxWidth: '100%',
  paddingTop: '16px !important'
});

export const EditDeclarationTableWrapper = styled(PageWrapper)({
  paddingTop: 0,
  margin: 0,
  maxWidth: '100%'
});

export const DeclarationFieldWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
});

export const ButtonWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  mb: 2
});

export const CloneDeclarationWrapper = styled(Box)({
  minWidth: 400,
  paddingTop: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 10
});
